import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import './CodeBlock.css';

const CodeBlock = ({ code, language = 'javascript', languages = null, title = null, showCopy = true }) => {
  // Gérer les langages: soit un tableau avec {id, name, code}, soit null
  const langArray = Array.isArray(languages) ? languages : null;
  
  // Déterminer le langage initial
  const initialLang = langArray && langArray.length > 0 ? langArray[0].id : language;
  const [selectedLang, setSelectedLang] = useState(initialLang);
  const [copied, setCopied] = useState(false);

  const selectedLangData = langArray?.find(lang => lang.id === selectedLang);
  const displayCode = selectedLangData?.code || code;
  const displayLanguage = langArray ? selectedLang : language;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(displayCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  // Mapping des langages pour Prism
  const prismLanguage = displayLanguage === 'curl' ? 'bash' : 
                        displayLanguage === 'javascript' ? 'javascript' :
                        displayLanguage === 'php' ? 'php' :
                        displayLanguage === 'python' ? 'python' :
                        displayLanguage === 'json' ? 'json' : 'javascript';

  return (
    <div className="code-block-wrapper">
      {title && (
        <div className="code-block-title">
          <span className="code-block-method">{title.method}</span>
          <span className="code-block-path">{title.path}</span>
        </div>
      )}
      
      {langArray && langArray.length > 0 && (
        <div className="code-block-tabs">
          {langArray.map((lang) => (
            <button
              key={lang.id}
              className={`code-block-tab ${selectedLang === lang.id ? 'active' : ''}`}
              onClick={() => setSelectedLang(lang.id)}
            >
              {lang.name}
            </button>
          ))}
          {showCopy && (
            <button className="code-block-copy" onClick={handleCopy} title="Copier le code">
              {copied ? '✓ Copié' : '📋 Copier'}
            </button>
          )}
        </div>
      )}

      <div className="code-block-container">
        <SyntaxHighlighter
          language={prismLanguage}
          style={vscDarkPlus}
          customStyle={{
            margin: 0,
            padding: '1.5rem',
            borderRadius: '0 0 8px 8px',
            fontSize: '0.875rem',
            lineHeight: '1.6'
          }}
          showLineNumbers={true}
        >
          {displayCode}
        </SyntaxHighlighter>
      </div>
    </div>
  );
};

export default CodeBlock;
